import { getScreenName } from '../../Utils/helper';

import { fireEvent } from '../../Utils/fireEvent';

export const clickedSearchTabEvent = (top) => {
  fireEvent({
    category: 'clicked_search_tab',
    screen_name: getScreenName(),
    position: top ? 'header menu' : ' below header menu',
  });
};

export const clearSearchTabEvent = (query) => {
  fireEvent({
    category: 'clear_search_result',
    screen_name: getScreenName(),
    query: query,
  });
};

export const searchResultShown = (query, num_results) => {
  fireEvent({
    category: 'search_results_shown',
    screen_name: getScreenName(),
    query: query,
    num_results: num_results,
  });
};

export const searchQueryEvent = (query) => {
  fireEvent({
    category: 'search_query',
    screen_name: getScreenName(),
    query: query,
  });
};

export const viewedGeneralScreenEvent = (query) => {
  fireEvent({
    category: 'viewed_general_screen',
    screen_name: getScreenName(),
    page_url: window?.location?.href,
    query: query,
  });
};
export const clickedCtaEvent = (query, cta, section_name) => {
  fireEvent({
    category: 'clicked_cta',
    screen_name: getScreenName(),
    page_url: window?.location?.href,
    query: query,
    cta: cta,
    section_name: section_name,
  });
};

export const servedSectionGeneralScreen = (
  card_ids,
  section_name,
  parentTag,
) => {
  fireEvent({
    category: 'served_section_in_general_screen',
    screen_name: getScreenName(),
    page_url: window?.location?.href,
    section_name: section_name,
    card_ids: card_ids,
    parent: parentTag,
  });
};
export const clickedCardInGeneralScreen = (
  query,
  section_name,
  parentTag,
  card_id,
  card_name,
  deeplink_value,
  content_type,
) => {
  fireEvent({
    category: 'clicked_card_in_general_screen',
    screen_name: getScreenName(),
    query: query,
    page_url: window?.location?.href,
    section_name: section_name,
    card_id: card_id,
    card_name: card_name,
    parent: parentTag,
    deeplink_value: deeplink_value,
    content_type: content_type, //<article/video/discussion/product>
  });
};
